import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    requestedAmountMissing: {
        id: '_.apply_flexi_loan.requestedAmount.validation.missing',
        defaultMessage: 'Please enter an amount'
    },
    requestedAmountTooLow: {
        id: '_.apply_flexi_loan.requestedAmount.validation.tooLow',
        defaultMessage: 'Please enter an amount greater than {minAmount}'
    },
    requestedAmountTooHigh: {
        id: '_.apply_flexi_loan.requestedAmount.validation.tooHigh',
        defaultMessage: 'Please enter an amount less than {maxAmount}'
    },
    loanPurposeValidation: {
        id: '_.apply_flexi_loan.loanPurpose.validation',
        defaultMessage: 'Please select a purpose for the funds'
    },
    turnoverValidation: {
        id: '_.apply_flexi_loan.turnover.validation',
        defaultMessage: 'Please enter your turnover of the last 12 months'
    },
    cardSalesValidation: {
        id: '_.apply_flexi_loan.cardSales.validation',
        defaultMessage: 'Please select an option'
    },
    loanDurationValidation: {
        id: '_.apply_flexi_loan.loanDuration.validation',
        defaultMessage: 'Bitte wählen Sie eine Laufzeit aus'
    }
});
